import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'template-attribute-components-menu-inline',
  templateUrl: './template-attribute-components-menu-inline.component.html',
  styleUrls: ['./template-attribute-components-menu-inline.component.scss'],
  standalone: false,
})
export class TemplateAttributeComponentsMenuInlineComponent {
  @Input() key = 0;
  @Input() isUserComponents = false;
  @Input() componentVisibility = true;
  @Input() componentRequiresUpgrade = false;
  @Input() isDataComponent = false;
  @Input() showVisibilityToggle = true;
  @Input() showDuplicateAction = true;
  @Input() displayName = '';

  @Output() rename = new EventEmitter<number>();
  @Output() visibilityChange = new EventEmitter<boolean>();
  @Output() duplicate = new EventEmitter<number>();
  @Output() remove = new EventEmitter<number>();

  /**
   * Mouse pointer down would normally focus the icon button; the row then
   * stays :focus-within after the pointer leaves. Skip focus for mouse only
   * so visibility stays hover-driven for pointer users. Keyboard/touch unchanged.
   */
  onPointerDownMouseOnly(event: PointerEvent): void {
    if (event.pointerType === 'mouse' && event.button === 0) {
      event.preventDefault();
    }
  }

  onRename(): void {
    this.rename.emit(this.key);
  }

  onVisibilityChange(visible: boolean): void {
    this.visibilityChange.emit(visible);
  }

  onDuplicate(): void {
    this.duplicate.emit(this.key);
  }

  onRemove(): void {
    this.remove.emit(this.key);
  }
}
